import { render } from "./CRMWhatsappContactsView.vue?vue&type=template&id=8b498cc0&scoped=true"
import script from "./CRMWhatsappContactsView.vue?vue&type=script&lang=js"
export * from "./CRMWhatsappContactsView.vue?vue&type=script&lang=js"

import "./CRMWhatsappContactsView.vue?vue&type=style&index=0&id=8b498cc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b498cc0"]])

export default __exports__